<template>
    <div class="news-card" v-if="cardArr != null">
        <!-- <breadcrumbs></breadcrumbs> -->
        <div class="container">
            <div class="card-title">
                <strong class="news-date">{{correctDate(cardArrDate)}}</strong>
                <h2>{{parseTitle(cardArr.title)}}</h2>
            </div>

            <!-- <BanerTopVertical :options="[{page: 'news-card'}]" class="news-card-vertical-baner-top" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true'"></BanerTopVertical> -->
            
            <div class="news-card-desc-main default-desc-main-red" v-if="cardArr.first_elem_default != undefined">
                <div class="desc-column-container">
                    <div class="column-left">
                        <div class="desc-red">
                            <p v-for="item in cardArr.first_elem_default.desc_red" v-html="item.desc"></p>
                        </div>
                        <div class="col-img-mobile">
                            <img :src="cardArr.first_elem_default.img" alt="">
                        </div>
                        <div class="desc-base">
                            <p v-for="item in cardArr.first_elem_default.desc_red_under" v-html="item.desc"></p>
                        </div>
                    </div>
                    <div class="column-right">
                        <div class="col-img">
                            <img :src="cardArr.first_elem_default.img" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <pageDescUniq :options="[{title: cardArr.desc_border_red, data_page: 'Новость - ' + cardArr.title, data_page_key: 'news_card'}]" :class="{'hide-ui' : cardArr.ui_visible_desc_border_red != undefined && cardArr.ui_visible_desc_border_red == 'true'}"v-if="cardArr.desc_border_red != undefined && cardArr.visible_desc_border_red != undefined && cardArr.visible_desc_border_red == 'true'"></pageDescUniq>
            
            <div class="news-standart-desc" v-if="cardArr.standart_big_desc != undefined && cardArr.standart_big_desc.init != undefined && cardArr.standart_big_desc.init == 'true'">
                <div class="column-container">
                    <div class="col-left">
                        <div class="desc-col" v-html="cardArr.standart_big_desc.desc_left"></div>
                    </div>
                    <div class="col-right">
                        <div class="desc-col" v-html="cardArr.standart_big_desc.desc_right"></div>
                    </div>
                </div>
            </div>

            <div class="news-card-desc-second" v-if="cardArr.second_news_elem != undefined">
                <div class="second-desc-item" v-for="(item, index) in cardArr.second_news_elem" v-if="item.visible == 'true'">
                    <div class="col-left">
                        <div class="desc-info" v-html="item.editor"></div>
                        <div class="desc-info-text-mobile">
                            <div class="desc-img-mobile">
                                <img :src="item.img" alt="">
                            </div>
                            <div class="desc-full" v-html="item.editor"></div>
                        </div>
                    </div>
                    <div class="col-right">
                        <div class="desc-img">
                            <img :src="item.img" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="news-card-big-desc" v-if="cardArr.big_info_element != undefined && cardArr.big_info_element.visible != undefined && cardArr.big_info_element.visible == 'true'">
            <div class="container">
                <div class="big-desc-item">
                    <div class="col-left">
                        <div class="desc-info" v-html="cardArr.big_info_element.desc_main"></div>
                        <!-- <div class="desc-info-text-mobile">
                            <div class="desc-img-mobile">
                                <img :src="cardArr.big_info_element.img" alt="">
                            </div>
                            <div class="desc-full" v-html="cardArr.big_info_element.desc_main"></div>
                        </div> -->
                    </div>
                    <div class="col-right">
                        <div class="desc-img">
                            <img :src="cardArr.big_info_element.img" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="big-red-under-desc">
                <div class="container">
                    <div class="column-container-big">
                        <div class="column-left">
                            <div class="desc-info desc-info-white" v-html="cardArr.big_info_element.desc_left"></div>
                        </div>
                        <div class="column-right">
                            <div class="desc-info desc-info-white" v-html="cardArr.big_info_element.desc_right"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="news-card-video" v-if="cardArr.video_news != undefined && cardArr.video_news.visible == 'true'">
            <div class="container">
                <div class="video-news-title">
                    <h2>{{cardArr.video_news.title}}</h2>
                </div>
                <div class="video-item">
                    <a href="#" class="link-open-modal" @click.prevent="initVideo = true" :class="{'disabled' : initVideo}">
                        <svgIcon name="play"/>
                        <div class="video-item-img">
                            <img :src="cardArr.video_news.img_preview" alt="">
                        </div>
                    </a>
                    <div class="video-player" :class="{'active' : initVideo}" v-if="initVideo">
                        <iframe :src="cardArr.video_news.video_link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                    </div>
                </div>
               
            </div>
        </div>

        <div class="news-card-gallery" v-if="cardArr.gallery_news != undefined && cardArr.gallery_news.visible == 'true'">
            <div class="container">
                <div class="gallery-title">
                    <h2>{{cardArr.gallery_news.title}}</h2>
                </div>
                <div class="news-card-gallery-carousel">
                    <swiper :options="swiperOption" ref="newsCardGalleryCarousel">
                        <swiper-slide v-for="(slide, index) in cardArr.gallery_news.gallery" :key="index">
                            <div class="slide-pic" :style="'background-image: url(' + slide + ')'"></div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-controls news-card-gallery-controls">
                        <div class="gal-news-btn-prev slider-btn">
                            <svgIcon name="left-arrow"/>
                        </div>
                        <div class="gal-news-btn-next slider-btn">
                            <svgIcon name="right-arrow"/>
                        </div>
                    </div>
                    <div class="swiper-pagination gal-news-pagination"></div>
                </div>
            </div>
        </div>
        <formPage class="form-page-news-card"></formPage>
        <!-- <div class="container">
            <sharePostBottom :options="[{title: 'Поделиться новостью:', data_title: parseTitle(cardArr.title), data_link: 'https://sales.bazis.kz/news/' + cardID, data_page: 'Новость - ' + parseTitle(cardArr.title), data_page_key: 'news_card'}]"></sharePostBottom>
        </div> -->
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    // import sharePostBottom from '@/components/share/share-social-bottom.vue'
	import formPage from '@/components/forms/form-page.vue';	
    import pageDescUniq from '@/components/page-static-desc-uniq/desc-uniq.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import store from '@/store.js'
    export default {
        name: 'news-card',
        components: {
            // sharePostBottom,
            pageDescUniq,
            formPage,
            svgIcon,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                lang: window.GlobalLang,
                cardArrDate: null,
                cardArr: null,
                anotherArr: null,
                initVideo: false,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.gal-news-btn-next',
                        prevEl: '.gal-news-btn-prev',
                    },
                    pagination: {
                        el: '.gal-news-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        methods: {
            // getData() {
            //     return new Promise((resolve, reject) => {
            //         // console.log('init')
            //         if (this.newsItemsFilter.length != 0) {
            //             var data = this.newsItemsFilter;
            //             // console.log(data, 'asdasasd')
            //             var filteredItem = data.filter(item => {
            //                 return item.slug === this.cardID
            //             });
            //             // var anotherItems = data.filter(item => {
            //             //     return item.slug != this.cardID
            //             // });
            //             // this.anotherArr = anotherItems;
            //             // console.log(filteredItem, 'SUKA');
            //             if (filteredItem.length != 0) {
            //                 this.cardArr = filteredItem[0];
            //                 this.$store.commit('setCustomCrumb', this.cardArr.title);
            //                 resolve('init1');
            //             } else {
            //                 //PUSH ON 404 PAGE
            //             }
                        
            //         } else {
            //             axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news?slug=' + this.cardID).then(async (response) => {
            //                 // console.log(response, this.cardID, 'from-news-card');
            //                 if (response.data.length != 0) {
            //                     this.cardArr = response.data[0].acf;
            //                     this.$store.commit('setCustomCrumb', this.cardArr.title);
            //                     resolve('init2');
            //                 } else {
            //                     //PUSH ON 404 PAGE
            //                 }
            //             });
            //         }
            //     });
            // },
            parseTitle(title) {
                var temporalDivElement = document.createElement("div");
                temporalDivElement.innerHTML = title;
                return temporalDivElement.textContent || temporalDivElement.innerText || "";
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8, 10));
                var month = date.slice(5, 7);
                var year = date.slice(0, 4);
                var monthFont;
                var total;
                var monthNames = {
                    '01': { 'kz/': 'Қаңтар', 'en/': 'January', 'default': 'Января' },
                    '02': { 'kz/': 'Ақпан', 'en/': 'February', 'default': 'Февраля' },
                    '03': { 'kz/': 'Наурыз', 'en/': 'March', 'default': 'Марта' },
                    '04': { 'kz/': 'Сәуiр', 'en/': 'April', 'default': 'Апреля' },
                    '05': { 'kz/': 'Мамыр', 'en/': 'May', 'default': 'Мая' },
                    '06': { 'kz/': 'Маусым', 'en/': 'June', 'default': 'Июня' },
                    '07': { 'kz/': 'Шiлде', 'en/': 'July', 'default': 'Июля' },
                    '08': { 'kz/': 'Тамыз', 'en/': 'August', 'default': 'Августа' },
                    '09': { 'kz/': 'Қыркүйек', 'en/': 'September', 'default': 'Сентября' },
                    '10': { 'kz/': 'Қазан', 'en/': 'October', 'default': 'Октября' },
                    '11': { 'kz/': 'Қараша', 'en/': 'November', 'default': 'Ноября' },
                    '12': { 'kz/': 'Желтоқсан', 'en/': 'December', 'default': 'Декабря' }
                };
                monthFont = monthNames[month] ? monthNames[month][this.lang] || monthNames[month]['default'] : '';
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
        },
        computed: mapGetters({
            pageSetup: 'loadNewsPage',
            currentCityArr: 'loadCurrentCityArr',
            newsItems: 'loadNewsItems',
            newsItemsDefault: 'loadNewsItemsDefault',
            newsItemsFilter: 'loadNewsItemsFilter',
            banerSystem: 'loadBanerSystem',
        }),
        beforeRouteEnter (to, from, next) {
            // console.log(to);
            store.dispatch('getNewsItems');
            store.dispatch('getNewsPageData');
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news?slug=' + to.params.id).then(async (response) => {
                // console.log(response);
                if (response.data.length != 0) {
                    next(vm => {
                        vm.cardArrDate = response.data[0].date;
                        vm.cardArr = response.data[0].acf;
                        vm.$store.commit('setCustomCrumb', vm.parseTitle(vm.cardArr.title));
                        vm.$store.commit('removePageLoaderImg');
                        vm.$parent.$refs.topProgress.done();
                    });
                } else {
                    next('/404', vm => vm.$parent.$refs.topProgress.fail());
                    //PUSH ON 404 PAGE
                }
            });
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
        },
        created () {
            document.body.dataset.page = 'news-card';

        },
        mounted () {
            // this.getData();
            // this.$store.watch(
            //     (state) => state.actionsItemsFilter,
            //     (newValue) => {
            //         if (newValue) {
            //             this.getData();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news/news-card.scss';
    @import '@/styles/respond/news/news-card-respond.scss';
</style>